/**
 * @author: subhasish.ghosh@zoom.us
 */

import { Alert, Box, CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { columnsIndustry } from "@options/dataGrid";
import sankeyOptions from "@options/GoogleCharts/sankey";
import { isSelectedActionTypeTNS } from "@utils/utils";
import { AgCharts } from "ag-charts-react";
import React from "react";
import Chart from "react-google-charts";

const IndustryDataSection = ({
  industryPieData,
  industrySankeyData,
  showAllIndustryData,
  industryTableData,
  selectedActionType,
  pieDataLoading,
  industryDataLoading,
  userActionDataLoading,
}) => (
  <>
    {!userActionDataLoading && !pieDataLoading && !industryDataLoading ? (
      !showAllIndustryData ? (
        isSelectedActionTypeTNS(selectedActionType) ? (
          <Chart
            chartType="Sankey"
            chartEvents={[
              {
                eventName: "select",
                callback: ({ chartWrapper }) => {
                  const chart = chartWrapper.getChart();
                  const selection = chart.getSelection();
                  if (selection.length === 0) return;
                },
              },
            ]}
            className="industry-fraud-sankey"
            height="500px"
            width="100%"
            data={industrySankeyData}
            options={sankeyOptions}
            legendToggle
          />
        ) : (
          <AgCharts options={industryPieData} style={{ height: "500px" }} />
        )
      ) : (
        <Box sx={{ marginBottom: "4px", height: "469px", overflow: "auto" }}>
          <DataGrid
            pagination={false}
            hideFooter={true}
            rows={industryTableData}
            columns={columnsIndustry(selectedActionType)}
            disableRowSelectionOnClick
            autoHeight={false}
            rowHeight={35}
            columnHeaderHeight={80}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                fontWeight: "bold",
              },
              "& .MuiDataGrid-scrollbar": {
                position: "absolute",
              },
            }}
          />
        </Box>
      )
    ) : (
      <div className="tile-centralise-content">
        <CircularProgress size="3rem" />
      </div>
    )}
    {!pieDataLoading && !showAllIndustryData && industryTableData?.length ? (
      <Alert
        variant="standard"
        severity="info"
        style={{
          padding: "0 10px",
          fontSize: "0.8rem",
          textAlign: "left",
        }}
      >
        The chart displays the top 10 entries by count. Subscriptions without an
        industry are not included. For complete details, please refer to the
        table by clicking on the table icon.
      </Alert>
    ) : (
      <></>
    )}
  </>
);

export default IndustryDataSection;
